import { StandardProps } from "../../componentMap";
import { useVariant } from "../../../hooks/useVariant/useVariant";
import { GalleryTeaserUI } from "./GalleryTeaserUI";

type GalleryProps = Pick<StandardProps, "product" | "configProps">;

export const GalleryTeaser = ({ product, configProps }: GalleryProps) => {
  const { variant } = useVariant(product);
  const galleryElementId =
    (configProps?.galleryElementId as string) || "image-gallery";

  return (
    <GalleryTeaserUI
      selectedVariant={variant}
      galleryElementId={galleryElementId}
    />
  );
};
